import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import useComplianceHubEnabled from 'utils/Hooks/LaunchDarkly/useComplianceHubEnabled';

import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import SalesNavigationIcon from '../../Icons/NavigationItem/Sales';

const LazyOOSalesPage = React.lazy(() => import('./Pages/OOSalesPage'));
const LazyTenantSalesPage = React.lazy(() => import('./Pages/TenantSalesPage'));
const isComplianceHubEnabled = () => useComplianceHubEnabled();

const salesConfiguration: FeatureConfiguration = {
    name: 'Sales',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureSalesTitle',
            url: '/sales',
            Icon: SalesNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyOOSalesPage />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyTenantSalesPage />
                </React.Suspense>
            ),
        },
        permissions: [UserPermissions.ViewPendingSales, UserPermissions.SubmitSales, UserPermissions.ViewSales],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (isComplianceHubEnabled()) {
            return false;
        }

        if (settings && settings.sale) {
            return settings.sale.visible;
        }

        return false;
    },
};

export default salesConfiguration;
